/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Manage_Rename_TitleInputs */

const en_us2_coach_manage_rename_title = /** @type {(inputs: Coach_Manage_Rename_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rename conversation`)
};

const pt_br2_coach_manage_rename_title = /** @type {(inputs: Coach_Manage_Rename_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renomear conversa`)
};

const es_419_coach_manage_rename_title = /** @type {(inputs: Coach_Manage_Rename_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renombrar conversación`)
};

const pt_pt2_coach_manage_rename_title = /** @type {(inputs: Coach_Manage_Rename_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mudar o nome da conversa`)
};

const fr_fr2_coach_manage_rename_title = /** @type {(inputs: Coach_Manage_Rename_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renommer la conversation`)
};

const de_de2_coach_manage_rename_title = /** @type {(inputs: Coach_Manage_Rename_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterhaltung umbenennen`)
};

const it_it2_coach_manage_rename_title = /** @type {(inputs: Coach_Manage_Rename_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rinomina conversazione`)
};

/**
* | output |
* | --- |
* | "Rename conversation" |
*
* @param {Coach_Manage_Rename_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_manage_rename_title = /** @type {((inputs?: Coach_Manage_Rename_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Manage_Rename_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_manage_rename_title(inputs)
	if (locale === "es-419") return es_419_coach_manage_rename_title(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_manage_rename_title(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_manage_rename_title(inputs)
	if (locale === "de-DE") return de_de2_coach_manage_rename_title(inputs)
	if (locale === "it-IT") return it_it2_coach_manage_rename_title(inputs)
	return en_us2_coach_manage_rename_title(inputs)
});
export { coach_manage_rename_title as "coach-manage.rename_title" }